<template>
	<div class="setting-layout">
		<ms-dropdown
			:width="isExpandedLayout ? 900 : 648"
			:height="'100vh'"
			ref="layoutDropdown"
			@close="closeDropdown"
			:closeDropDownWithScroll="false"
			:customPosition="{
				top: 0,
				right: 0,
				bottom: 0,
				left: 'unset',
			}"
			:styleDropdown="{
				'border-radius': 'unset',
			}"
			:menuDropdownNoBorderRadius="true"
			:isCalculatorPostionTop="false"
			:overflow="'visible'"
		>
			<template slot="icon">
				<div
					class="flex items-center justify-center ms-height-32px ms-width-32px"
					v-tooltip="{
						content: $t('i18nCommon.ConfigLayout'),
						placement: 'bottom-end',
					}"
				>
					<div class="mi-new-v2 mi-20 mi-icon-v2-action-setup"></div>
				</div>
			</template>
			<div
				class="toggle-expand-layout"
				v-tooltip="{
					content: isExpandedLayout
						? $t('i18nCommon.CollapseTooltip')
						: $t('i18nCommon.ExpandTooltip'),
					placement: 'top',
				}"
				@click="toggleExpandLayout"
			>
				<div
					class="mi-new-v2 mi-16"
					:class="
						isExpandedLayout
							? 'mi-icon-v2-next-page'
							: 'mi-icon-v2-previos-page'
					"
				></div>
			</div>
			<div
				class="dropdown-menu-layout"
				:class="{ 'is-expanded': isExpandedLayout }"
			>
				<div class="header-layout flex">
					<div class="flex justify-between w-full">
						<div class="title-header-form-h2">
							{{ $t('i18nCommon.ConfigLayout') }}
						</div>
						<div
							@click="cancel"
							class="flex mi-new-v2 mi-20 mi-icon-v2-close-lg cursor-pointer"
						></div>
					</div>
				</div>
				<div class="filter-layout ms-mgb-16px">
					<ms-input-search-auto-complete
						class="ms-input-search-config-layout"
						:placeholder="$t('i18nCommon.Search')"
						iconLeft="mi mi-16 mi-new-v2 mi-icon-v2-check-again search-prefix-icon"
						v-model="searchValue"
						@change="changeSearch"
						:autoComplete="false"
						:keyData="'configLayout'"
					></ms-input-search-auto-complete>
				</div>
				<div class="list-coloumn-layout">
					<div
						class="grid-viewer flex-box"
						:class="noBorderLastRow ? 'grid-viewer-no-border-last-row' : ''"
					>
						<ms-grid-viewer
							ref="gridSupplierList"
							:columns="columnLayoutAction"
							:data="columnx"
							multiple
							:draggable="true"
							v-model="selected"
							:keyFieldData="'dataField'"
							:gridViewClass="'grid-has-border'"
							:isCheckboxHasAfter="true"
							@input="changeSelected"
							@dragChange="onGridDragChange"
							:noDataSlot="true"
							:gridOptions="{ hideLastRowBorderOnScroll: true }"
						>
							<template slot="noData">
								<div class="config-layout-nodata items-center justify-center">
									<div class="flex justify-center">
										<div class="mi mi-new-v2 image-no-filter-stick"></div>
									</div>
									<div class="ms-mgt-16px">
										{{ $t('i18nCommon.FilterLayoutAgain') }}
									</div>
								</div>
							</template>
						</ms-grid-viewer>
					</div>
				</div>
				<div class="toolbar-action">
					<div class="flex justify-between w-full">
						<div class="flex items-center">
							<ms-button
								:title="$t('i18nCommon.RestoreDefaults')"
								class="btn-size btn-restore-default"
								type="secondary"
								@click="resetBackToDefaultLayout"
							></ms-button>
						</div>
						<div class="flex items-center">
							<ms-button
								:title="$t('i18nCommon.Cancel')"
								class="btn-size btn-cancel"
								type="secondary"
								@click="cancel"
							></ms-button>
							<ms-button
								:title="$t('i18nCommon.Save2')"
								class="btn-size ms-mgl-8px btn-save"
								@click="applyLayout"
								:disabled="selected && selected.length === 0"
							></ms-button>
						</div>
					</div>
				</div>
			</div>
		</ms-dropdown>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { ModuleLayout } from '@/store/module-const';
import ColumnModel from '@/model/ColumnModel.js';
import configLayoutFieldNameTemplate from './configLayoutFieldNameTemplate.vue';
export default {
	name: 'msConfigLayout',
	components: {},
	props: {
		//Cấu hình các cột truyền vào
		/**
		 * Các thuộc tính trong columns
		 * @params dataField Field dữ liệu dùng để nhận giá trị thay đổi và hiện thị.
		 * @params title:Tiêu đề của cột
		 * @params width:độ rộng của cột
		 * @params autoResize:Cột tự động to ra khi màn hình lớn
		 * @params formatType:Dữ liệu dùng để format lấy từ trong file enumeration.js FormatType
		 */
		columns: {
			default: () => [],
		},
		customLayout: {},
		LayoutID: {
			default: null,
			type: String,
		},
		autoResizeList: {
			default: () => [],
		},
		/**
		 * Có lấy dùng config title trong db hay không
		 */
		isConfigTitleDb: {
			default: false,
			type: Boolean,
		},
		/**
		 * Bỏ border-bottom ở dòng cuối cùng của bảng
		 */
		noBorderLastRow: {
			default: false,
			type: Boolean,
		},
	},
	created() {
		const me = this;
		me.initDataStatic();
	},
	async mounted() {
		const me = this;
		await me.loadLayoutConfig();
	},
	data() {
		return {
			searchValue: null,
			columnx: [],
			colHoverx: null,
			index: 0,
			isSystem: false,
			selected: [],
			columnLayoutAction: [],
			isExpandedLayout: false,
		};
	},
	computed: {
		...mapGetters(ModuleLayout, ['LayoutInfos']),
		//Kiểm tra layout checkbox check tất cả
		//Created by LTDAT (04.08.2020)
		isCheckedMultiple() {
			const me = this;
			let itemCheck = me.columns.filter((item) => {
				return item.visiable == true;
			});
			return itemCheck.length == me.columns.length;
		},

		getColumnVisible() {
			const me = this;
			if (!me.columnx || me.columnx.length == 0) return [];
			return me.columnx.filter((x) => x.visiable);
		},

		//Không có dữ liệu sau khi filter - chỉ cho đóng form, không thực hiện chức năng
		hasNoData() {
			const me = this;
			return !me.columnx || me.columnx.length == 0;
		},
	},
	methods: {
		...mapActions(ModuleLayout, ['loadLayout', 'saveLayout', 'resetLayout']),
		initDataStatic() {
			const me = this;
			me.isExpandedLayout = false;
			me.columnLayoutAction = [
				{
					title: me.$t('i18nCommon.FieldName'),
					template: configLayoutFieldNameTemplate,
					templateProps: {
						layoutID: me.LayoutID,
					},
				},
			];
		},
		closeDropdown(outSize) {
			const me = this;
			me.columnx = me.oldConfig || [];
			me.searchValue = null;
			me.isExpandedLayout = false;
			me.setColumnLayout(me.columnx);
		},
		changeSearch(value) {
			const me = this;
			if (value && value.trim()) {
				if (me.isConfigTitleDb) {
					me.columnx = me.columns.filter((item) => {
						return (
							item.title &&
							item.title.toString() &&
							item.title.toString().toLowerCase().contains(value.toLowerCase())
						);
					});
				} else {
					me.columnx = me.columns.filter((item) => {
						return (
							me.$t(`i18nLayout.${me.LayoutID}`)[`${item.dataField}`] &&
							`${me.$t(`i18nLayout.${me.LayoutID}`)[`${item.dataField}`]}`
								.toLowerCase()
								.contains(value.toLowerCase())
						);
					});
				}
			} else {
				me.columnx = me.columns || [];
			}
		},
		async loadLayoutConfig() {
			const me = this;
			let layoutInfos =
				me.$store.state.layout && me.$store.state.layout.LayoutInfos
					? me.$store.state.layout.LayoutInfos
					: [];
			//Chưa cached thông tin thiết lập client - call DB lấy thiết lập mới
			if (
				!layoutInfos ||
				!layoutInfos[`${me.LayoutID}`] ||
				Object.keys(layoutInfos[`${me.LayoutID}`]).length <= 0
			) {
				await me.loadLayout(me.LayoutID);
			}

			if (me.$store.state.layout) {
				//Phải lấy dữ liệu từ store (sử dụng getters đang k lấy được dữ liệu(chưa biết nguyên nhân - đang nghĩ do vuex lỗi))
				let layoutInfos = me.$store.state.layout.LayoutInfos;
				if (layoutInfos) {
					let layoutInfo = layoutInfos[`${me.LayoutID}`];
					if (layoutInfo) {
						me.isSystem = layoutInfo.IsSystem;
						let columns = JSON.parse(layoutInfo.LayoutValue);
						me.setColumnLayout(columns);
					}
				}
			}
		},
		setColumnLayout(columns) {
			const me = this;
			if (columns && columns.length == 0) {
				return;
			}

			if (columns) {
				me.columnx = columns || [];
				me.oldConfig = JSON.parse(JSON.stringify(me.columnx));
				me.columnx.forEach((item) => {
					me.mappingResizeCol(me.columnx, true);
					if (typeof me.customLayout == 'function') {
						me.customLayout(item, true);
					}
				});
				// Khởi tạo selected từ visiable để checkbox hiển thị đúng
				me.selected = me.columnx.filter(
					(x) => x.visiable && x.isConfig != false
				);
				me.$emit('update:columns', me.columnx);
				me.$emit('apply', me.columnx);
			}
		},
		mappingResizeCol(columns, isAddNew) {
			const me = this;
			columns.forEach((item) => {
				if (isAddNew) {
					if (
						me.autoResizeList &&
						me.autoResizeList.length > 0 &&
						me.autoResizeList.includes(item.dataField)
					) {
						me.$set(item, 'autoResize', true);
					} else {
						delete item.autoResize;
					}
				} else {
					delete item.autoResize;
				}
				delete item._width;
				delete item._minWidth;
			});
		},
		//Sự kiến ấn vào nút Áp dụng trong cấu hình cột
		//Created by LTDAT (04.08.2020)
		async applyLayout() {
			const me = this;
			if (me.hasNoData) {
				me.$refs.layoutDropdown.closeDropdownMenu();
				return;
			}
			if (me.selected && me.selected.length == 0) {
				return;
			}

			me.$refs.layoutDropdown.closeDropdownMenu();
			let columns = JSON.parse(JSON.stringify(me.columns));
			if (typeof me.customLayout == 'function') {
				columns.forEach((item, index) => {
					columns[index] = me.setModelColumn(item);
				});
			}
			let payload = {
				LayoutId: me.LayoutID,
				LayoutValue: JSON.stringify(columns),
				IsSystem: me.isSystem,
			};
			await me.saveLayout(payload);
			me.setColumnLayout(columns);
		},
		setModelColumn(col) {
			const me = this;
			col = new ColumnModel(col);
			return col;
		},
		//Sự kiện ấn vào nút hủy bỏ trên thanh cấu hình cột
		//Created by LTDAT (04.08.2020)
		cancel() {
			const me = this;
			me.$refs.layoutDropdown.closeDropdownMenu();
			me.columnx = me.oldConfig || [];
			me.searchValue = null;
			me.setColumnLayout(me.columnx);
		},

		//Sự kiện ấn vào icon thu nhỏ/mở rộng form cấu hình cột
		toggleExpandLayout() {
			const me = this;
			me.isExpandedLayout = !me.isExpandedLayout;
		},

		//Sự kiện ấn vào nút Mặc định trên màn hình cấu hình cột
		//Created by NTNHAN (3/12/2020)
		async resetBackToDefaultLayout() {
			const me = this;
			if (me.hasNoData) {
				me.$refs.layoutDropdown.closeDropdownMenu();
				return;
			}
			let params = {
					layoutId: me.LayoutID,
				},
				res = await me.resetLayout(params);
			if (res && res.Success) {
				me.$emit('resetToDefault');
				me.$refs.layoutDropdown.closeDropdownMenu();
				await me.loadLayoutConfig();
			}
		},
		changeSelected(payload) {
			const me = this;
			console.log(payload, 'changeSelected');

			// Đồng bộ visiable từ trạng thái selection của grid
			me.columnx.forEach((col) => {
				if (col.isConfig != false) {
					const isSelected =
						Array.isArray(payload) &&
						payload.some((x) => x.dataField === col.dataField);
					me.$set(col, 'visiable', isSelected);
				}
			});
		},

		onGridDragChange(reorderedData) {
			const me = this;
			me.columnx = reorderedData;
			me.$emit('update:columns', me.columnx);
			me.$emit('apply', me.columnx);
		},
	},
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1366px) {
	@import '@/assets/scss/_sm-variables.scss';
	@import '@/assets/scss/components/ms-config-layout.scss';
}

@media screen and (min-width: 1367px) {
	@import '@/assets/scss/_variables.scss';
	@import '@/assets/scss/components/ms-config-layout.scss';
}
</style>